import React, { useState } from "react";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../CommonComponents/RightDrawer";
import { Tabs, Tab } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fieldsConfig, PaymentFieldGroups } from "../../utils/fieldsConfig";
import { formatDate } from "../../utils/commonutils";
import ModuleFollowups from "../CommonComponents/ModuleFollowups";
import AttachmentPanel from "../CommonComponents/AttachmentPanel";

const asId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value._id) return String(value._id);
  return String(value);
};

const displayValue = (name, data) => {
  if (fieldsConfig[name].type === "date") return formatDate(data[name]) || "—";
  if (name === "portalPassword") return data[name] ? "••••••••" : "—";
  if (name === "amount" && data[name]) return `₹${data[name]}`;
  return data[name] || "—";
};

const PaymentRecoveryDetailModal = ({ isOpen, onClose, recoveryData, props }) => {
  const [tabValue, setTabvalue] = useState(0);
  const history = useHistory();
  const data = recoveryData || {};
  const customerId = asId(data.customerId);
  const inquiryId = asId(data.inquiryId);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose} kicker="Payment recovery">
        {data.applicantName || data.diaryNo || "Case details"}
      </ModalHeader>
      <ModalBody>
        <Tabs value={tabValue} onChange={(_, v) => setTabvalue(v)}>
          <Tab label="Details" />
          <Tab label="Follow-ups" />
          <Tab label="Attachments" />
        </Tabs>
        {tabValue === 0 && (
          <div>
            {(data.customerId || data.inquiryId) && (
              <div className="drawer-section">
                <h3 className="drawer-section-title">Linked records</h3>
                {data.customerId?.companyName || data.customerId?.name ? (
                  <div className="drawer-kv">
                    <span className="drawer-kv-label">Customer</span>
                    <span className="drawer-kv-value">
                      {customerId ? (
                        <button
                          type="button"
                          className="text-[13px] font-semibold text-[#1a3366] hover:underline bg-transparent border-0 p-0"
                          onClick={() => history.push(`/customers/${customerId}`)}
                        >
                          {data.customerId.companyName || data.customerId.name}
                        </button>
                      ) : (
                        data.customerId.companyName || data.customerId.name
                      )}
                    </span>
                  </div>
                ) : null}
                {inquiryId ? (
                  <div className="drawer-kv">
                    <span className="drawer-kv-label">Source inquiry</span>
                    <span className="drawer-kv-value">
                      <button
                        type="button"
                        className="text-[13px] font-semibold text-[#1a3366] hover:underline bg-transparent border-0 p-0"
                        onClick={() => history.push(`/inquiriedetail/${inquiryId}`)}
                      >
                        Open inquiry
                      </button>
                    </span>
                  </div>
                ) : null}
              </div>
            )}
            {PaymentFieldGroups.map((group) => (
              <div className="drawer-section" key={group.title}>
                <h3 className="drawer-section-title">{group.title}</h3>
                {group.fields.map((name) => (
                  <div className="drawer-kv" key={name}>
                    <span className="drawer-kv-label">{fieldsConfig[name].label}</span>
                    <span className="drawer-kv-value">{displayValue(name, data)}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        {tabValue === 1 && data._id && (
          <ModuleFollowups
            moduleName="payment_recovery"
            recordId={data._id}
            customerId={customerId}
            props={props}
          />
        )}
        {tabValue === 2 && data._id && (
          <AttachmentPanel moduleName="payment_recovery" recordId={data._id} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-border" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PaymentRecoveryDetailModal;
